import {Component, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionInfo } from 'src/app/model/transaction-info.model';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';
import { ClaimService } from 'src/app/services/claim.service';
import { ClaimPersonalAccident } from 'src/app/model/claim-personal-accident.model';
import { ClaimsBaseComponent } from 'src/app/claim-pages/claim-base.component';
import { takeUntil } from 'rxjs/operators';
import { SideMenuService } from 'src/app/services/side-menu.service';
import { HospitalExpenseDetails } from 'src/app/model/personal-accident/hospital-expense-details.model';
import { ClinicalExpenseDetails } from 'src/app/model/personal-accident/clinical-expense-details.model';
import { ClaimTypes } from 'src/app/model/claim-type.model';
import { HospitalExpenseHelperService } from 'src/app/services/hospital-expense-helper.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DateService } from 'src/app/ui/ui-datepicker/date.service';
import {MedicalCertificate} from "../../../../../model/personal-accident/medical-certificate.model";
import {OutpatientConsultDetails} from "../../../../../model/personal-accident/outpatient-consult-details.model";

@Component({
    selector: 'app-hospital-expenses',
    templateUrl: './hospital-expenses.component.html',
    styleUrls: ['./hospital-expenses.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HospitalExpensesComponent extends ClaimsBaseComponent  implements OnInit {

    showTotalBox = false;
    ameForm: FormGroup;
    hospitalExpenseForm: FormGroup;
    clinicalExpenseForm: FormGroup;
    transactionInfo: TransactionInfo;
    claimPA: ClaimPersonalAccident;
    currency: string;
    hospitalExpenseItems: HospitalExpenseDetails[];
    clinicalExpenseItems: ClinicalExpenseDetails[];
    hospitalExpenseHelperService: HospitalExpenseHelperService;
    hospitalCashFound: boolean = false;
    medCertForm: FormGroup;
    medicalCertificates: MedicalCertificate[] = [];
    icuForm: FormGroup;
    outpatientForm: FormGroup;
    outpatientConsultation: OutpatientConsultDetails;
    outpatientConsultationClinicalExpenses: ClinicalExpenseDetails[];
    outpatientConsultationClinicalExpenseForm: FormGroup;
    
    constructor(private fb: FormBuilder,
                private transactionInfoService: TransactionInfoService,
                private claimService: ClaimService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private injector : Injector,
                private sideMenuService: SideMenuService,
                private dateService: DateService) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.claimPA = this.claim.getClaimPersonalAccident();
        this.transactionInfo = this.transactionInfoService.getTransactionInfo();
        this.hospitalExpenseHelperService = this.injector.get(HospitalExpenseHelperService)
        this.outpatientConsultation = this.claimPA.getAccidentalMedicalExpenses().getOutpatientConsultation();
    }

    ngOnInit() {

        this.pushGAPageView();
        this.checkForHospitalCash();
        this.currency = UtilitiesService.getCountryCurrency(this.claim.getCountry());

        if (UtilitiesService.isNullOrUndefined(this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted())) {
            this.claimPA.getAccidentalMedicalExpenses().setWasAdmitted(false);
        }

        this.ameForm = this.fb.group({
            wasAdmitted: [super.getBooleanString(this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted())],
            wasMedCertIssued: [super.getBooleanString(this.claimPA.getAccidentalMedicalExpenses().getWasMedCertIssued())]
        });

        this.hospitalExpenseItems = this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getHospitalExpenses();
        this.hospitalExpenseForm = this.fb.group({
            items: this.fb.array(this.buildHospitalExpenseItems(this.hospitalExpenseItems))
        });

        this.clinicalExpenseItems = this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getClinicalExpenses();
        this.clinicalExpenseForm = this.fb.group({
            fullyRecovered: [super.getBooleanString(this.claimPA.getAccidentalMedicalExpenses().getFullyRecovered())],
            treatment: [this.claimPA.getAccidentalMedicalExpenses().getTreatment()],
            items: this.fb.array(this.buildClinicalExpenseItems(this.clinicalExpenseItems))
        });

        this.medicalCertificates = this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getMedicalCertificates();
        this.medCertForm = this.fb.group({
            items: this.fb.array(this.buildMedicalCertificateItems(this.medicalCertificates))
        });

        this.icuForm = this.fb.group({
            stayedIn: [super.getBooleanString(this.claimPA.getAccidentalMedicalExpenses().getStayedIn())],
            dateFrom: [this.claimPA.getAccidentalMedicalExpenses().getDateFrom()],
            dateTo: [this.claimPA.getAccidentalMedicalExpenses().getDateTo()]
        });

        this.outpatientForm = this.fb.group({
            hasOutpatientConsultations: [super.getBooleanString(this.outpatientConsultation.getHasOutpatientConsultations())]
        });

        this.outpatientConsultationClinicalExpenses = this.outpatientConsultation.getClinicalExpenses();
        this.outpatientConsultationClinicalExpenseForm = this.fb.group({
            fullyRecovered: [super.getBooleanString(this.outpatientConsultation.getFullyRecovered())],
            treatment: [this.outpatientConsultation.getTreatment()],
            items: this.fb.array(this.buildOutpatientConsultClinicalExpenseItems(this.outpatientConsultationClinicalExpenses))
        })

        setTimeout(() => {
            this.showSvgPath();
        }, 10);
    }

    ngAfterViewInit() {


        this.ameForm.valueChanges.subscribe(data => {
            if (this.ameForm.get('wasAdmitted').value !== null) {
                this.claimPA.getAccidentalMedicalExpenses().setWasAdmitted(this.ameForm.get('wasAdmitted').value == 'true');
            }
            if (this.ameForm.get('wasMedCertIssued').value !== null) {
                this.claimPA.getAccidentalMedicalExpenses().setWasMedCertIssued(this.ameForm.get('wasMedCertIssued').value == 'true');
            }
        });

        this.hospitalExpenseForm.valueChanges.subscribe(data => {

            let hospitalExpenses: HospitalExpenseDetails[] = [];

            for (let item of data.items) {

                let itemDetail : HospitalExpenseDetails = new HospitalExpenseDetails();

                itemDetail.setHospitalName(item.hospitalName)
                itemDetail.setDateAdmission(DateService.convertStringToDatetime(item.dateAdmission, 'dd/MM/yyyy HH:mm'));
                itemDetail.setDateDischarge(DateService.convertStringToDatetime(item.dateDischarge, 'dd/MM/yyyy HH:mm'));
                
                itemDetail.setHospitalExpenseCurrency(item.hospitalExpenseCurrency);
                itemDetail.setHospitalExpense(item.hospitalExpense);
            
                hospitalExpenses.push(itemDetail);
            }

            this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().setHospitalExpenses(hospitalExpenses);
        });

        this.clinicalExpenseForm.valueChanges.subscribe(data => {

            this.clinicalExpenseItems = [];

            data.items.forEach((details, index) => {
                let itemDetail : ClinicalExpenseDetails = new ClinicalExpenseDetails();

                itemDetail.setDateVisit(this.dateService.stringToDate(details.dateVisit, 'dd/MM/yyyy'));
                itemDetail.setMedicalAttention(details.medicalAttention);
                itemDetail.setMedicalAttentionDesc(super.getIndexedTextInComponent('medicalAttention', index));
                itemDetail.setMedicalAttentionOthers(details.medicalAttentionOthers);
                itemDetail.setClinicalExpense(details.clinicalExpense);
                itemDetail.setClinicalExpenseCurrency(details.clinicalExpenseCurrency);
                this.clinicalExpenseItems.push(itemDetail);
            });

            this.claimPA.getAccidentalMedicalExpenses().setClinicalExpenses(this.clinicalExpenseItems);

            if (this.clinicalExpenseForm.get('fullyRecovered').value !== null) {
                this.claimPA.getAccidentalMedicalExpenses().setFullyRecovered(this.clinicalExpenseForm.get('fullyRecovered').value == 'true');
            }
            this.claimPA.getAccidentalMedicalExpenses().setTreatment(super.getValueInComponent('treatment'));
        });

        let self = this;

       setTimeout(() => {self.hideTreatmentField(self.getBooleanString(self.claimPA.getAccidentalMedicalExpenses().getFullyRecovered()))},10);
       this.clinicalExpenseForm.get('fullyRecovered').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
           this.hideTreatmentField(data);
       });

        let formArray : FormArray =  <FormArray> self.clinicalExpenseForm.controls["items"];
        formArray.controls.forEach(function (formArrayItem) {
            formArrayItem.get('medicalAttention').valueChanges.pipe(takeUntil(self.ngUnsubscribe)).subscribe(data => {
                self.medicalAttentionChanged(data, formArrayItem);
            });
        });

        if(!this.claim.isHKGorHGI()){
            this.medCertForm.valueChanges.subscribe(data => {
                let medCerts: MedicalCertificate[] = [];
                for(let item of data.items) {

                    let itemDetail : MedicalCertificate = new MedicalCertificate();
                    itemDetail.setPeriodFrom(this.dateService.stringToDate(item.periodFrom, 'dd/MM/yyyy'));
                    itemDetail.setPeriodTo(this.dateService.stringToDate(item.periodTo, 'dd/MM/yyyy'));
                    itemDetail.setMedCertPurpose(item.medCertPurpose);

                    medCerts.push(itemDetail);
                }

                this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().setMedicalCertificates(medCerts);
            });

            this.icuForm.valueChanges.subscribe(data => {
                if (this.icuForm.get('stayedIn').value != null) {
                    this.claimPA.getAccidentalMedicalExpenses().setStayedIn(this.icuForm.get('stayedIn').value == 'true');
                }
                this.claimPA.getAccidentalMedicalExpenses().setDateFrom(super.getValueInComponent('dateFrom'));
                this.claimPA.getAccidentalMedicalExpenses().setDateTo(super.getValueInComponent('dateTo'));
            });

            setTimeout(() => {self.hideIcuFields(self.getBooleanString(self.claimPA.getAccidentalMedicalExpenses().getStayedIn()))},10);
            this.icuForm.get('stayedIn').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
                this.hideIcuFields(data);
            })

            this.outpatientForm.valueChanges.subscribe(data => {
                if (this.outpatientForm.get('hasOutpatientConsultations').value !== null) {
                    this.outpatientConsultation.setHasOutpatientConsultations(this.outpatientForm.get('hasOutpatientConsultations').value == 'true');
                }
            });

            this.outpatientConsultationClinicalExpenseForm.valueChanges.subscribe(data => {
                this.outpatientConsultationClinicalExpenses = [];

                for (let i = 0; i < data.items.length; i++) {
                    let itemDetail : ClinicalExpenseDetails = new ClinicalExpenseDetails();

                    itemDetail.setDateVisit(this.dateService.stringToDate(data.items[i].dateVisitOutpatient, 'dd/MM/yyyy'));
                    itemDetail.setMedicalAttention(data.items[i].medicalAttention);
                    itemDetail.setMedicalAttentionDesc(super.getIndexedTextInComponent("medicalAttention", i));
                    itemDetail.setMedicalAttentionOthers(data.items[i].medicalAttentionOthers);
                    itemDetail.setClinicalExpense(data.items[i].clinicalExpense);
                    itemDetail.setClinicalExpenseCurrency(data.items[i].clinicalExpenseCurrency);
                    this.outpatientConsultationClinicalExpenses.push(itemDetail);
                }

                this.outpatientConsultation.setClinicalExpenses(this.outpatientConsultationClinicalExpenses);
                if (this.outpatientConsultationClinicalExpenseForm.get('fullyRecovered').value !== null) {
                    this.outpatientConsultation.setFullyRecovered(this.outpatientConsultationClinicalExpenseForm.get('fullyRecovered').value == 'true');
                }
                this.outpatientConsultation.setTreatment(super.getValueInComponent('treatment'));
            });

            setTimeout(() => {self.hideOutpatientConsultationFields(self.getBooleanString(self.outpatientConsultation.getHasOutpatientConsultations()))},10);
            this.outpatientForm.get('hasOutpatientConsultations').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
                this.hideOutpatientConsultationFields(data);
            });


            setTimeout(() => {self.hideTreatmentField(self.getBooleanString(self.outpatientConsultation.getFullyRecovered()))},10);
            this.outpatientConsultationClinicalExpenseForm.get('fullyRecovered').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
                this.hideTreatmentField(data);
            });

            let formArray : FormArray =  <FormArray> self.outpatientConsultationClinicalExpenseForm.controls["items"];
            formArray.controls.forEach(function (formArrayItem) {
                formArrayItem.get('medicalAttention').valueChanges.pipe(takeUntil(self.ngUnsubscribe)).subscribe(data => {
                    self.medicalAttentionChanged(data, formArrayItem);
                });
            });
        }
    }

    buildHospitalExpenseItems(hospitalExpenses: HospitalExpenseDetails[]): FormGroup[] {

        let formGroupArray : FormGroup[] = [];

        if(hospitalExpenses != null && hospitalExpenses.length > 0 ) {
            for(let hospitalExpense of hospitalExpenses) {
                let rowFormGroup = this.fb.group({
                    hospitalName: [hospitalExpense.getHospitalName()],
                    dateAdmission: [hospitalExpense.getDateAdmission()],
                    dateDischarge: [hospitalExpense.getDateDischarge()],
                    hospitalExpense: [hospitalExpense.getHospitalExpense()],
                    hospitalExpenseCurrency: [hospitalExpense.getHospitalExpenseCurrency()]
                });
                formGroupArray.push(rowFormGroup);
            }
        }
        else {
            formGroupArray.push(this.createDefaultHospitalExpenseItems());
        }

        return formGroupArray;
    }

    createDefaultHospitalExpenseItems(): FormGroup {
        return this.fb.group({
            hospitalName: '',
            dateAdmission: null,
            dateDischarge: null,
            hospitalExpense: '',
            hospitalExpenseCurrency: this.currency
        });
    }

    buildOutpatientConsultClinicalExpenseItems(clinicalExpenses: ClinicalExpenseDetails[]): FormGroup[] {

        let formGroupArray : FormGroup[] = [];

        if(clinicalExpenses != null && clinicalExpenses.length > 0 ) {
            for(let clinicalExpense of clinicalExpenses) {
                let rowFormGroup = this.fb.group({
                    dateVisitOutpatient: [clinicalExpense.getDateVisit()],
                    medicalAttention: [clinicalExpense.getMedicalAttention()],
                    medicalAttentionDesc: [clinicalExpense.getMedicalAttentionDesc()],
                    medicalAttentionOthers: [clinicalExpense.getMedicalAttentionOthers()],
                    clinicalExpense: [clinicalExpense.getClinicalExpense()],
                    clinicalExpenseCurrency: [clinicalExpense.getClinicalExpenseCurrency()]
                });
                formGroupArray.push(rowFormGroup);
            }
        }
        else {
            formGroupArray.push(this.createDefaultItemOutpatientConsultItems());
        }

        return formGroupArray;
    }
    
    buildClinicalExpenseItems(clinicalExpenses: ClinicalExpenseDetails[]): FormGroup[] {

        let formGroupArray : FormGroup[] = [];

        if(clinicalExpenses != null && clinicalExpenses.length > 0 ) {
            for(let clinicalExpense of clinicalExpenses) {
                let rowFormGroup = this.fb.group({
                    dateVisit: [clinicalExpense.getDateVisit()],
                    medicalAttention: [clinicalExpense.getMedicalAttention()],
                    medicalAttentionDesc: [clinicalExpense.getMedicalAttentionDesc()],
                    medicalAttentionOthers: [clinicalExpense.getMedicalAttentionOthers()],
                    clinicalExpense: [clinicalExpense.getClinicalExpense()],
                    clinicalExpenseCurrency: [clinicalExpense.getClinicalExpenseCurrency()]
                });
                formGroupArray.push(rowFormGroup);
            }
        }
        else {
            formGroupArray.push(this.createDefaultClinicalExpenseItems());
        }

        return formGroupArray;
    }

    createDefaultClinicalExpenseItems(): FormGroup {
        return this.fb.group({
            dateVisit: null,
            medicalAttention: '',
            medicalAttentionDesc: '',
            medicalAttentionOthers: '',
            clinicalExpense: '',
            clinicalExpenseCurrency: this.currency
        });
    }

    addHospitalItem(): void {
        let self = this;
        setTimeout(function () {

            let items = self.hospitalExpenseForm.get('items') as FormArray;
            let newItem : FormGroup = self.createDefaultHospitalExpenseItems();
            items.push(newItem);

        }, 10);
    }
    
    removeHospitalItem(i) {
        let items = this.hospitalExpenseForm.get('items') as FormArray;
        items.removeAt(i);
        this.hospitalExpenseItems.splice(i, 1);
    }

    addClinicalItem(): void {
        let self = this;
        setTimeout(function () {

            let items = self.clinicalExpenseForm.get('items') as FormArray;
            let newItem : FormGroup = self.createDefaultClinicalExpenseItems();
            items.push(newItem);

            newItem.get('medicalAttention').valueChanges.pipe(takeUntil(self.ngUnsubscribe)).subscribe(data => {
                self.medicalAttentionChanged(data, newItem);
            });

        }, 10);
    }
    
    removeClinicalItem(idx: number) {
        let items = this.clinicalExpenseForm.get('items') as FormArray;
        items.removeAt(idx, {emitEvent: true});

        items.value.forEach(formItem =>{
            this.clinicalExpenseItems.forEach(item =>{
                if (item.getMedicalAttention() === formItem.medicalAttention) {
                    item.setMedicalAttentionDesc(formItem.medicalAttentionDesc);
                }
            });
        });
    }

    hideIcuFields(show) {
        if (show === "true") {
            this.icuForm.get('dateFrom').enable({onlySelf: false, emitEvent: false});
            this.icuForm.get('dateTo').enable({onlySelf: false, emitEvent: false});
        } else {
            this.icuForm.get('dateFrom').reset();
            this.icuForm.get('dateFrom').disable({onlySelf: false, emitEvent: false});
            this.icuForm.get('dateTo').reset();
            this.icuForm.get('dateTo').disable({onlySelf: false, emitEvent: false});
        }
    }

    hideOutpatientConsultationFields(hasConsultation) {
        if (hasConsultation === "true") {
            this.toggleForms(this.outpatientConsultationClinicalExpenseForm, true);
        } else {
            this.outpatientConsultation.setClinicalExpenses(null);
            this.toggleForms(this.outpatientConsultationClinicalExpenseForm, false);
        }
    }

    hideFields(wasAdmitted) {
        if (wasAdmitted === "true") {
            this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().setClinicalExpenses(null);
            this.toggleForms(this.hospitalExpenseForm, true);
            this.toggleForms(this.clinicalExpenseForm, false);
            this.hideShowHospitalSubMenu(true);
        } else if (wasAdmitted === "false") {
            this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().setHospitalExpenses(null);
            this.toggleForms(this.clinicalExpenseForm, true);
            this.toggleForms(this.hospitalExpenseForm, false);
            this.hideShowHospitalSubMenu(false);
        } else {
            this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().setClinicalExpenses(null);
            this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().setHospitalExpenses(null);
            this.toggleForms(this.clinicalExpenseForm, false);
            this.toggleForms(this.hospitalExpenseForm, false);
            this.hideShowHospitalSubMenu(false);
        }
    }

    hideShowHospitalSubMenu(showFlag: boolean) {
        this.sideMenuService.emitClaimTypeSubMenuHideShow({claimTypeId: 0, subMenuIndex: 1,
            value: ClaimTypes[ClaimTypes.CLAIM_TYPE_PA_ACCIDENTAL_MEDICAL_EXPENSES], show: showFlag});
        this.sideMenuService.emitClaimTypeSubMenuHideShow({claimTypeId: 0, subMenuIndex: 2,
            value: ClaimTypes[ClaimTypes.CLAIM_TYPE_PA_ACCIDENTAL_MEDICAL_EXPENSES],  show: showFlag});
    }

    hideTreatmentField(hasRecovered) {
        if (String(hasRecovered) === 'false') {
            this.clinicalExpenseForm.get('treatment').enable({onlySelf: false, emitEvent: false});
        } else if (String(hasRecovered) === 'true') {
            this.clinicalExpenseForm.get('treatment').reset();
            this.clinicalExpenseForm.get('treatment').disable({onlySelf: false, emitEvent: false});
        }
    }

    toggleForms(form: FormGroup, show: boolean) {
        if(show){
            form.enable({onlySelf: false, emitEvent: false});
        } else {
            form.disable({onlySelf: false, emitEvent: false});
        }
    }

    getCurrencyValue(val: any) : string {
        if(val == null || (val != null && val == '')) {
            return this.currency;
        }
        return val;
    }

    medicalAttentionChanged(medicalAttention, formGroup) {
        if (medicalAttention === 'Others') {
            formGroup.get('medicalAttentionOthers').enable({onlySelf: false, emitEvent: false});
        } else  {
            formGroup.get('medicalAttentionOthers').disable({onlySelf: false, emitEvent: false});
        }
    }

    goToNext() {
        if (this.validateForm()) {
            this.sideMenuService.emitClaimComplete({claimTypeId: 0, subMenuIndex: 0});
            let url = this.claim.getCountry().toLowerCase() === 'sgp' ? "/claimform/anotherInsurance"
                : "/claimform/accidentalMedicalExpenses/supportDoc";
            this.router.navigate([url], {
                relativeTo: this.activatedRoute
            });

        }
    }

    validateMoneyFields(wasAdmitted: boolean): boolean {

        let data = wasAdmitted ? this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getHospitalExpenses() : this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getClinicalExpenses();
        let moneyField = wasAdmitted ? "hospitalExpense" : "clinicalExpense";
        data.forEach((currVal) => {
            let formArray: FormArray = <FormArray>this.hospitalExpenseForm.controls["items"];
            formArray.controls.forEach((currentValue) => {
                if (currentValue.get(moneyField).value == ''
                    || currentValue.get(moneyField).value == null) {
                    return false;
                }
            });
        });
        return false;
    }

    validateForm(): boolean {
        let wasAdmitted = this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getWasAdmitted();
        if(super.validateForm(this.ameForm)){
            let expensesValidated = false;
            const medCertValidated = super.validateForm(this.medCertForm);
            if(wasAdmitted){
                expensesValidated = super.validateForm(this.hospitalExpenseForm);
                expensesValidated = super.validateForm(this.icuForm) && expensesValidated;
                expensesValidated = super.validateForm(this.outpatientForm) && expensesValidated;
            } else if (!wasAdmitted) {
                expensesValidated = super.validateForm(this.clinicalExpenseForm);
            }
            return expensesValidated && medCertValidated;
        }
        return false;
    }

    back() {
        this.sideMenuService.emitProgress(-1);
        const route = this.transactionInfo.getAvailableClaimTypes().length === 1 ? "/claimform/paInjuryDetails" : "/claimform/claimDetail/selectClaim";
        this.router.navigate([route], {
            relativeTo: this.activatedRoute
        });
    }

    getHospitalDate(filter: string): Date {
        let hospitalExpenses: HospitalExpenseDetails[] = this.claim.getClaimPersonalAccident().getAccidentalMedicalExpenses().getHospitalExpenses();
        if (UtilitiesService.isNullOrUndefined(hospitalExpenses) || hospitalExpenses.length == 0) {
            return null;
        } else {
            if (filter === 'a') {
                return hospitalExpenses.reduce((oldest, current) => {
                    const currentEntry = current.getDateAdmission();
                    if (!currentEntry) return oldest;
                    return (!oldest || currentEntry < oldest) ? currentEntry : oldest;
                }, null as Date | null);
            } else {
                return hospitalExpenses.reduce((latest, current) => {
                    const currentEntry = current.getDateDischarge();
                    if (!currentEntry) return latest;
                    return (!latest || currentEntry > latest) ? currentEntry : latest;
                }, null as Date | null);
            }
        }
    }

    getICUDatesForValidation(filter: string): [Date, Date[][], Date] {
        if (filter === 'a') {
            return [this.getHospitalDate('a'), null, this.getHospitalDate('d')];
        }
        return [this.claimPA.getAccidentalMedicalExpenses().getDateFrom(), null, this.getHospitalDate('d')];
    }

    getDatesForValidation(i, fieldType): [Date, Date[][], Date] {
        return this.hospitalExpenseHelperService.getDatesForValidation(i, fieldType, this.claimPA.getAccidentalMedicalExpenses().getHospitalExpenses());
    }

    checkForHospitalCash() {
        this.transactionInfo.getClaimTypeItemList().forEach(element => {
            if(element.claimTypeCode == ClaimTypes[ClaimTypes.CLAIM_TYPE_PA_HOSPITAL_CASH] && element.show == true){
                this.hospitalCashFound = true;
            }
        });
    }

    showModal() {
        this.showTotalBox = true;
    }

    getData(msg) {
        this.showTotalBox = msg;
    }

    pushGAPageView() {
        let pageStep = this.transactionInfo.getGaPageStep() + ' - Hospital/Clinical Expense';
        let vPath = this.transactionInfo.getGaVPath() + '/hospital-clinical-expense';
        (<any>window).dataLayer = (<any>window).dataLayer || [];
        (<any>window).dataLayer.push({
            'pageStep': pageStep,
            'vPath': vPath,
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 6}
                }
            }
        });
    }

    createDefaultMedicalCertificateItems(): FormGroup {
        return this.fb.group({
            periodFrom: null,
            periodTo: null,
            medCertPurpose: ''
        });
    }

    addMedCertItem(): void {
        let self = this;
        setTimeout(function () {
            let items = self.medCertForm.get('items') as FormArray;
            let newItem : FormGroup = self.createDefaultMedicalCertificateItems();
            if (items.length < 5) {
                items.push(newItem);
            }
        }, 10);
    }

    removeMedCertItem(i) {
        let items = this.medCertForm.get('items') as FormArray;
        items.removeAt(i);
        this.medicalCertificates.splice(i, 1);
    }

    buildMedicalCertificateItems(medicalCertificates: MedicalCertificate[]): FormGroup[] {
        let formGroupArray : FormGroup[] = [];

        if(medicalCertificates !== null && medicalCertificates.length > 0 ) {
            for(let medCert of medicalCertificates) {
                let rowFormGroup = this.fb.group({
                    periodFrom: [medCert.getPeriodFrom()],
                    periodTo: [medCert.getPeriodTo()],
                    medCertPurpose: [medCert.getMedCertPurpose()]
                });
                formGroupArray.push(rowFormGroup);
            }
        }
        else {
            formGroupArray.push(this.createDefaultMedicalCertificateItems());
        }

        return formGroupArray;
    }

    createDefaultItemOutpatientConsultItems(): FormGroup {
        return this.fb.group({
            dateVisitOutpatient: null,
            medicalAttention: '',
            medicalAttentionDesc: '',
            medicalAttentionOthers: '',
            clinicalExpense: '',
            clinicalExpenseCurrency: this.currency
        });
    }

    addItemOutpatientConsultItem(): void {
        let self = this;
        setTimeout(function () {

            let items = self.outpatientConsultationClinicalExpenseForm.get('items') as FormArray;
            let newItem : FormGroup = self.createDefaultItemOutpatientConsultItems();
            items.push(newItem);

            newItem.get('medicalAttention').valueChanges.pipe(takeUntil(self.ngUnsubscribe)).subscribe(data => {
                self.medicalAttentionChanged(data, newItem);
            });

        }, 10);
    }

    removeItemOutpatientConsultItem(i) {
        let items = this.outpatientConsultationClinicalExpenseForm.get('items') as FormArray;
        items.removeAt(i);

        items.value.forEach(formItem =>{
            this.outpatientConsultationClinicalExpenses.forEach(item =>{
                if (item.getMedicalAttention() === formItem.medicalAttention) {
                    item.setMedicalAttentionDesc(formItem.medicalAttentionDesc);
                }
            });
        });
    }

}
